module.exports = __webpack_public_path__ + "img/el-ic-identity-red.98808e74.svg";